// import React, { useState } from "react";
// import { useLocation, useParams, useNavigate } from "react-router-dom";
// import { useUploadBankPaymentNowMutation } from "../api/billingApi";

// export default function AdminRecordPaymentPage() {
//   const { userId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const { chargeIds, total } = location.state || {};

//   const [file, setFile] = useState<File | null>(null);

//   const [uploadPayment, { isLoading }] = useUploadBankPaymentNowMutation();

//   const handleSubmit = async () => {
//     if (!file) {
//       alert("Please upload receipt");
//       return;
//     }

//     const form = new FormData();

//     form.append("user_id", userId!);
//     form.append("amount", total);

//     chargeIds.forEach((id: number) => {
//       form.append("charge_price_ids[]", id);
//     });

//     form.append("receipt", file);

//     try {
//       await uploadPayment(form).unwrap();

//       alert("Payment recorded successfully");

//       navigate(-1);
//     } catch (err) {
//       alert("Payment failed");
//     }
//   };

//   return (
//     <div className="max-w-xl mx-auto space-y-6">
//       <h1 className="text-xl font-bold">Record Bank Payment</h1>

//       <div className="bg-white border rounded-2xl p-6 space-y-4">
//         <div>
//           <div className="text-sm text-gray-500">Total Payment</div>

//           <div className="text-2xl font-bold">
//             ₦{Number(total).toLocaleString()}
//           </div>
//         </div>

//         <div>
//           <label className="text-sm font-medium">Upload Receipt</label>

//           <input
//             type="file"
//             onChange={(e) => setFile(e.target.files?.[0] || null)}
//           />
//         </div>

//         <button
//           onClick={handleSubmit}
//           disabled={isLoading}
//           className="w-full bg-gray-900 text-white py-3 rounded-xl"
//         >
//           {isLoading ? "Recording..." : "Submit Payment"}
//         </button>
//       </div>
//     </div>
//   );
// }
import React, { useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useUploadBankPaymentNowMutation } from "../api/billingApi";

export default function AdminRecordPaymentPage() {
  const { userId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { chargeIds, total } = location.state || {};

  const [file, setFile] = useState<File | null>(null);
  const [amount, setAmount] = useState<number>(total || 0); // <-- new state

  const [uploadPayment, { isLoading }] = useUploadBankPaymentNowMutation();

  const handleSubmit = async () => {
    if (!file) {
      alert("Please upload receipt");
      return;
    }

    if (!amount || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    const form = new FormData();

    form.append("user_id", userId!);
    form.append("amount", amount.toString()); // <-- use input amount

    chargeIds.forEach((id: any) => {
      form.append("charge_price_ids[]", String(id));
    });

    form.append("receipt", file);

    try {
      await uploadPayment(form).unwrap();

      alert("Payment recorded successfully");
      navigate(-1);
    } catch (err) {
      alert("Payment failed");
    }
  };

  return (
    <div className="max-w-xl mx-auto space-y-6">
      <h1 className="text-xl font-bold">Record Bank Payment</h1>

      <div className="bg-white border rounded-2xl p-6 space-y-4">
        <div>
          <div className="text-sm text-gray-500">Total Payment</div>

          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
            className="text-2xl font-bold w-full border rounded-lg p-2"
            min={0}
          />
        </div>

        <div>
          <label className="text-sm font-medium">Upload Receipt</label>

          <input
            type="file"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className="w-full bg-gray-900 text-white py-3 rounded-xl"
        >
          {isLoading ? "Recording..." : "Submit Payment"}
        </button>
      </div>
    </div>
  );
}
